var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9471 4.26647C10.7665 4.29596 10.5974 4.40621 10.5107 4.49323L10.1506 4.85466L11.1551 5.8629L11.5119 5.50477C11.5985 5.41785 11.7091 5.24745 11.7387 5.06458C11.7621 4.9202 11.7457 4.72787 11.5119 4.49323C11.2783 4.25877 11.0883 4.24338 10.9471 4.26647ZM10.2702 6.75107L9.26571 5.74283L6.87428 8.14314C5.94612 9.07475 5.19294 10.1649 4.65004 11.3615C5.87621 10.8117 6.992 10.0415 7.94155 9.0884L10.2702 6.75107ZM10.7449 3.02914C11.2806 2.9416 11.8779 3.08425 12.4001 3.60835C12.9221 4.13228 13.0631 4.73013 12.9763 5.2653C12.8957 5.76198 12.6284 6.1605 12.4001 6.38965L11.5992 7.19351L8.82971 9.97328C7.69862 11.1086 6.35579 12.0109 4.87729 12.6292L4.13872 12.9381C3.45742 13.223 2.77588 12.5334 3.06882 11.8555L3.41887 11.0455C4.02922 9.63306 4.90015 8.34826 5.98611 7.25827L8.82163 4.41222L9.62252 3.60835C9.85072 3.37931 10.2484 3.11027 10.7449 3.02914Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.a53086f770f5f6d31d5517e58c1db8d5.svg";
export { ForwardRef as ReactComponent };